/**
 * navigation.js
 *
 * Handles toggling the navigation menu for small screens.
 */
jQuery(function($) {
	var container = document.getElementById( 'site-navigation' ),
	    button    = container.getElementsByTagName( 'button' )[0],
	    menu      = container.getElementsByTagName( 'ul' )[0],
	    html      = document.getElementsByTagName('html')[0];

	if ( undefined == button || undefined == menu )
		return false;

	button.onclick = function() {
		if (html.classList.contains('no-scroll')) {
			html.classList.remove('no-scroll');
		}
		else {
			html.classList.add('no-scroll');
		}

		if ( -1 == menu.className.indexOf( 'nav-menu' ) ) {
			menu.className = 'nav-menu';
		}

		if ( -1 != button.className.indexOf( 'toggled-on' ) ) {
			button.className = button.className.replace( ' toggled-on', '' );
			menu.className = menu.className.replace( ' toggled-on', '' );
			container.className = container.className.replace( 'main-small-navigation', 'main-navigation' );
		} else {
			button.className += ' toggled-on';
			menu.className += ' toggled-on';
			container.className = container.className.replace( 'main-navigation', 'main-small-navigation' );
		}
	};

	// 2023 Updates
	// add aria-expanded to menu items with children
	$('.menu-item-has-children > a').attr('aria-expanded', 'false');
	$('.menu-item-has-children > a').hover(function() {
		$(this).attr('aria-expanded', 'true');
	}
	, function() {
		$(this).attr('aria-expanded', 'false');
	});

	// add aria-label to nav items contain 'PuSh'
	$('#site-navigation .menu-item-has-children:first ul.sub-menu li a').each(function() {
		if ($(this).html().indexOf('PuSh') >= 0) {
			var push = $(this).html().replace('PuSh', '<span aria-label="Push">PuSh</span>');
			$(this).html(push);
		}
	});

	// keyboard accessibility
	$('#site-navigation .menu-item-has-children').keydown(function(e) {
		if (e.key === ' ' || e.key === 'Enter' || e.key === 'ArrowDown') {
			e.preventDefault();
			$(this).children('a').attr('aria-expanded', 'true');
			$(this).children('ul').show();
			$(this).children('ul').find('a').first().focus();
		}
		if (e.key === 'ArrowLeft') {
			e.preventDefault();
			$(this).children('a').attr('aria-expanded', 'false');
			$(this).children('ul').hide();
			if ($(this).prev().length === 0) {
				$(this).parent().children('li:last-child').children('a').focus();
			} else {
				$(this).prev().children('a').focus();
			}
		}
		if (e.key === 'ArrowRight') {
			e.preventDefault();
			$(this).children('a').attr('aria-expanded', 'false');
			$(this).children('ul').hide();
			if ($(this).next().length === 0) {
				$(this).parent().children('li:first-child').children('a').focus();
			}
			else {
				$(this).next().children('a').focus();
			}
		}
	});
	$('#site-navigation .menu-item ul.sub-menu li a').keydown(function(e) {
		if (e.key === 'Enter') {
			e.stopPropagation();
			$(this).click();
		}
		if (e.key === ' ') {
			e.preventDefault();
			e.stopPropagation();
			// click is not working
			window.location.href = $(this).attr('href');
		}
		if (e.key === 'Escape') {
			e.preventDefault();
			$(this).parent().parent().hide();
			$(this).parent().parent().siblings('a').attr('aria-expanded', 'false');
			$(this).parent().parent().siblings('a').focus();
		}
		if (e.key === 'ArrowUp') {
			e.preventDefault();
			if ($(this).parent().prev().length === 0) {
				$(this).parent().siblings('li').last().children('a').focus();
			} else {
				$(this).parent().prev().children('a').focus();
			}
		}
		if (e.key === 'ArrowDown') {
			e.preventDefault();
			e.stopPropagation(); // Prevent event from bubbling up to parent
			if ($(this).parent().next().length === 0) {
				$(this).parent().siblings('li').first().children('a').focus();
			} else {
				$(this).parent().next().children('a').focus();
			}
		}
	});

	$('#site-navigation .menu-item ul.sub-menu li:last-child a').keydown(function(e) {
		if (e.key === 'Tab') {
			$(this).parent().parent().hide();
			$(this).parent().parent().siblings('a').attr('aria-expanded', 'false');
		}
	});

	// Desktop dropdowns: one highlight per menu, the sub-menu's ::before
	// (sass/header/_navigation.scss). It glides to the hovered or focused item
	// and, when the pointer leaves, rests on the current page's item or
	// hides. Taps don't move it, and the phone menu doesn't have it.
	var desktop = window.matchMedia('(min-width: 768px)');

	$('#site-navigation .menu > li > .sub-menu').each(function() {
		var sub     = this,
		    parent  = sub.parentElement,
		    current = sub.querySelector(':scope > li.current-menu-item > a:not([href*="#"])'),
		    hovered = null;

		sub.classList.add('has-highlight');

		// Returns false when the menu isn't laid out (closed).
		function place(link) {
			if (!link) {
				sub.classList.remove('highlight-on');
				return true;
			}
			var h = link.offsetHeight;
			if (!h) return false;
			sub.style.setProperty('--highlight-y', link.offsetTop + 'px');
			sub.style.setProperty('--highlight-h', h + 'px');
			sub.classList.add('highlight-on');
			return true;
		}

		function rest() {
			if (!desktop.matches) return;
			var focused = sub.contains(document.activeElement) && document.activeElement.tagName === 'A' ? document.activeElement : null;
			var target = hovered || focused || current;
			if (!place(target)) {
				// Opening on a tap can lay the menu out a frame later.
				requestAnimationFrame(function() { place(target); });
			}
		}

		parent.addEventListener('pointerover', function(e) {
			if (!desktop.matches) return;
			var item = e.target.closest('li');
			if (item && item.parentElement === sub) {
				if (e.pointerType === 'touch') return;
				hovered = item.querySelector('a');
				place(hovered);
			} else if (!sub.contains(e.target)) {
				// On the section's own link: the menu is opening (or the
				// pointer came back up from it).
				rest();
			}
		});

		parent.addEventListener('pointerenter', function() {
			// The key handlers above close a menu with an inline display: none,
			// which would stop hover opening it again.
			if (sub.style.display === 'none') sub.style.display = '';
		});

		sub.addEventListener('pointerleave', function() {
			hovered = null;
			rest();
		});

		sub.addEventListener('focusin', function(e) {
			if (desktop.matches && e.target.tagName === 'A') place(e.target);
		});

		sub.addEventListener('focusout', function() {
			setTimeout(function() {
				if (!sub.contains(document.activeElement)) rest();
			});
		});
	});

	$('#site-navigation .current_page_item').click(function() {
		$(html).removeClass('no-scroll');
		$(button).removeClass('toggled-on');
		$(menu).removeClass('toggled-on');
		$(container).removeClass('main-small-navigation').addClass('main-navigation');
	});

	window.addEventListener('resize', function() {
		if ( window.innerWidth >= 568 && -1 != button.className.indexOf( 'toggled-on') ) {
			button.className = button.className.replace( ' toggled-on', '' );
			menu.className = menu.className.replace( ' toggled-on', '' );
			container.className = container.className.replace( 'main-small-navigation', 'main-navigation' );
		}
		if (window.innerWidth >= 568) {
			document.getElementsByTagName('html')[0].classList.remove('no-scroll');
		}
	});

	// Hide menu toggle button if menu is empty.
	if ( ! menu.childNodes.length )
		button.style.display = 'none';
});
